import React from 'react';
import ReactDOM from 'react-dom';

import './styles/style.css';
import App from './components/App';

ReactDOM.render(<App/>, document.getElementById('root'));
